import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CORE_API_BASE_URL;
let automationBaseUrl = process.env.REACT_APP_CORE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";
automationBaseUrl = automationBaseUrl + "api/v1";

export class AutomationNetworkService {
  static getAutomationList(data: any) {
    const { limit, offset, search, tag, status } = data;
    const url = `${automationBaseUrl}${Endpoints.AUTOMATION_LIST}`;
    const params = { limit, offset, search, tag, status };

    return http.get(url, { params });
  }
  static deleteAutomation(id: any) {
    return http.delete(
      `${automationBaseUrl}${Endpoints.AUTOMATION_DEFAULT}/${id}`,
      {},
    );
  }
  static createAutomation(data: any) {
    return http.post(
      `${automationBaseUrl}${Endpoints.AUTOMATION_CREATE}`,
      data,
    );
  }
  static getAutomationById(id: string) {
    return http.get(`${automationBaseUrl}${Endpoints.AUTOMATION_BY_ID}/${id}`);
  }
  static updateAutomationById(id: string, payload: any) {
    return http.put(
      `${automationBaseUrl}${Endpoints.AUTOMATION_BY_ID}/${id}`,
      payload,
    );
  }
  static publishAutomationById(id: string) {
    return http.post(`${automationBaseUrl}${Endpoints.AUTOMATION_BY_ID}/${id}`);
  }

  static unPublishAutomationById(id: string) {
    return http.put(
      `${automationBaseUrl}${Endpoints.UNPUBLISH_AUTOMATION_BY_ID}/${id}`,
    );
  }

  static getModelConfigByType(type: string) {
    return http.get(`${consoleBaseUrl}${Endpoints.AUTOMATION_DEFAULT}/${type}`);
  }

  static getApplicationsList() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_APPLICATIONS_LIST}`);
  }
  static postAutomationFolder(data: any) {
    return http.post(`${automationBaseUrl}${Endpoints.CREATE_FOLDER}`, data);
  }

  static applyAutomationFolder(data: any) {
    return http.post(
      `${automationBaseUrl}${Endpoints.AUTOMATION_FOLDER_APPLY}`,
      data,
    );
  }
  static deleteAutomationFolder(data?: any) {
    return http.post(
      `${automationBaseUrl}${Endpoints.AUTOMATION_FOLDER_DELETE}`,
      data,
    );
  }
  static getDateMatchOptions(){
    return http.get(`${automationBaseUrl}${Endpoints.GET_DATE_MATCH}`);
  }
  static getWebhooksList(data:any) {
    return http.post(`${consoleBaseUrl}${Endpoints.GET_WEBHOOK_LIST}`,data);
  }
  // 
  static googleSheetAuthCallBack (data?:any){
    return http.post(`${consoleBaseUrl}${Endpoints.GOOGLE_SHEET_AUTH_CALLBACK}`, data);
  }
    static getConnectedGoogleAccounts (data?:any){
    return http.get(`${consoleBaseUrl}${Endpoints.GET_ALL_CONNECTED_ACCOUNTS}`,{params:{...data}});
  }
    static getGoogleSheets (data?:any){
    return http.get(`${consoleBaseUrl}${Endpoints.GET_ALL_GOOGLE_SHEET}`, {params:{...data}});
  }
   static getGoogleSheetsFields (data?:any){
    return http.get(`${consoleBaseUrl}${Endpoints.GET_ALL_GOOGLE_SHEET_DETAILS}`, {params:{...data}});
  }
  static resisterGoogleSheetWebhook (data?:any){
    return http.post(`${consoleBaseUrl}${Endpoints.REGISTER_GOOGLE_SHEET_WEBHOOK}`, data);
  }
  static saveNodeConfig(data: any) {
    return http.post(`${automationBaseUrl}${Endpoints.SAVE_NODE_CONFIG}`, data);
  }
}

class Endpoints {
  static AUTOMATION_LIST = "/workspace/automation/list";
  static AUTOMATION_DEFAULT = "/workspace/automation";
  static AUTOMATION_CREATE = "/workspace/automation/create";
  static AUTOMATION_BY_ID = "/workspace/automation";
  static CREATE_FOLDER = "/workspace/create-automation-folder";
  static AUTOMATION_FOLDER_APPLY = "/workspace/add-automation-folders";
  static AUTOMATION_FOLDER_DELETE = "/workspace/remove-folder-from-automation";

  static UNPUBLISH_AUTOMATION_BY_ID = "/workspace/automation/unpublish";
  static GET_APPLICATIONS_LIST = "/workspace/automation/application-list";
  static GET_DATE_MATCH="/workspace/get-datetime-fields"

  static GET_WEBHOOK_LIST = "/workspace/get-webhooks";

  static GOOGLE_SHEET_AUTH_CALLBACK = "/workspace/google-sheet/auth-callback"
  static GET_ALL_CONNECTED_ACCOUNTS = "/workspace/google-sheet/connected-accounts"
  static GET_ALL_GOOGLE_SHEET = "/workspace/google-sheet/list"
  static GET_ALL_GOOGLE_SHEET_DETAILS = "/workspace/google-sheet/details"
  static REGISTER_GOOGLE_SHEET_WEBHOOK = "/workspace/google-sheet/register-webhook"
  static SAVE_NODE_CONFIG = "/workspace/automation/build-update";
}
